import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { LegsEintrag } from "../../Api/DcoApi/Admin/AdminClasses2";
import { RestClient } from "../../Api/DcoApi/Client/RestClient";
import { AdminCard } from "../Controlls/Sonstige/AdminCard";
import { DateSelect } from "../../Akte/Controlls/DateSelect";

@Component({
  selector: 'LegsEdit',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminCard, DateSelect],
  templateUrl: './LegsEdit.html',
  styleUrl: './LegsEdit.css'
})

export class LegsEdit {
  @Input() Key: number = 0;
  @Input() PG: number = 0;
  @Input() Legs: string = '';
  Client: RestClient = new RestClient();
  LegsEntry: LegsEintrag | null = null;

  get Item(): LegsEintrag {
    if (this.LegsEntry == null)
      this.LegsEntry = { legs: this.Legs, pg: this.PG } as LegsEintrag

    return this.LegsEntry;

  }


  async Send() {
    if (this.LegsEntry != null)
      this.modal.close(await this.Client.Post<LegsEintrag, LegsEintrag>(`/Backend/Api/V2/Admin/KooperationsPartner/${this.Key}/Legs`, this.LegsEntry))
  }

  modal = inject(NgbActiveModal);
}
